import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Routes, RouterModule, UrlSerializer, RouterLinkActive } from "@angular/router";
import { AppMaterialModule } from "../app.material.module";
import { PropertiesRoutingModule } from "./properties-routing.module";
import { UserPropertiesComponent } from "./user-properties/user-properties.component";
import { PropertiesService } from "./services/properties.service";
import { NewUserpropertiesComponent } from "./new-userproperties/new-userproperties.component";
import { NewAppPropertiesComponent } from "./new-app-properties/new-app-properties.component";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { EditUserpropertiesComponent } from "./edit-userproperties/edit-userproperties.component";
import { DatastorePropertiesComponent } from "./datastore-properties/datastore-properties.component";
import { MatFormFieldModule } from "@angular/material/form-field";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    PropertiesRoutingModule,
    AppMaterialModule,
    MatSortModule,
    MatTableModule,
    MatFormFieldModule,
  ],
  declarations: [
    UserPropertiesComponent,
    NewUserpropertiesComponent,
    NewAppPropertiesComponent,
    EditUserpropertiesComponent,
    DatastorePropertiesComponent,
  ],
  providers: [PropertiesService],
})
export class PropertiesModule {}
